import { Location as LocationType, SpecialLocation } from "../models";

/**
 * Utility function to get display text for a location
 * @param location Location or SpecialLocation object
 * @returns Formatted display text
 */
export const getLocationDisplayText = (
  location: LocationType | SpecialLocation,
): string => {
  return location.HeaderText || "Unknown Location";
};
